import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PremiseHazardTypePageComponent } from './premise-hazard-type/premise-hazard-type-page/premise-hazard-type-page.component';
import PremiseHazardsPageComponent from './premise-hazards/premise-hazard-page/premise-hazard-page.component';
import { roleGuard } from '@services/role-guard';
import { OrganizationConfigurationComponent } from './organization-configuration/organization-configuration.component';
import { TemplateConstants } from '@constants/template-constants';
import { UnauthorizedComponent } from './unauthorized-component/unauthorized.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'hazards',
    pathMatch: 'full'
  },
  {
    path: 'hazards',
    component: PremiseHazardsPageComponent,
    canActivate: [roleGuard([TemplateConstants.QueryPermissionName, TemplateConstants.CommandPermissionName, TemplateConstants.UploadPermissionName, TemplateConstants.AdminPermissionName])],
  },
  {
    path: 'types',
    component: PremiseHazardTypePageComponent,
    canActivate: [roleGuard([TemplateConstants.QueryPermissionName, TemplateConstants.CommandPermissionName, TemplateConstants.UploadPermissionName, TemplateConstants.AdminPermissionName])],
  },
  {
    path: 'organization-configuration',
    component: OrganizationConfigurationComponent,
    canActivate: [roleGuard([TemplateConstants.AdminPermissionName])],
  },
  {
    path: 'unauthorized',
    component: UnauthorizedComponent,
  }
];

@NgModule({
  declarations: [],
  imports: [RouterModule.forRoot(routes, { paramsInheritanceStrategy: 'always' })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
